import React, { useEffect, useState, PureComponent } from 'react';

import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

export default function Download ({type, activity, remove, errors, register, name, icon, fileError}) {
    
    const [filename, setFilename] = useState(activity['data']['fileName']);
    const changeFile = event => {
        setFilename(event.target.files[0].name);
    };        
    const { ref, ...rest } = register('data[assetUrl]');
    
    return (
        
        <>
        
            <div className="title"> 
                <div>
                    <div className="icon"><img src={icon} alt="" /></div>
                    <div className="name">Settings {name}</div>
                </div>
                <div>
                    <div className="icon qrcode"><QrcodePurple /></div>
                    <div className="icon remove" onClick={remove}><Remove /></div>
                </div>
            </div>

            
            <label>Enter {name} name</label>
            <input 
                type="text"
                {...register("name", { required: "Name is required" })}
                placeholder={name + " name"}
                defaultValue={activity['name']}
            />
            <div className="error">{errors.name?.message}</div>                                

            
            <div className="subtitle">File</div>
            <label>Upload the asset</label>


            <input 
                type="hidden" 
                {...register("data[assetUrl_last_value]", {})}
                defaultValue={activity['data']['assetUrl']} 
            />
            <input 
                type="hidden" 
                {...register("data[fileName]", {})}
                defaultValue={filename} 
            />
            <label>
                <input 
                    type="file"
                    {...register("data[assetUrl]", {})}
                    placeholder={"Url"}
                    onChange={changeFile}
                />
                <div className="button">Upload</div>
            </label>
            
            {filename}            
            <div className="error">{fileError}</div>

            <div className="subtitle">Image Preview URL</div>
            <label>Enter image preview URL (optional)</label>
            <input 
                type="text"
                {...register("data[imgPreview]", {})}
                placeholder="Image preview URL"
                defaultValue={activity['data']['imgPreview']}
            />
            
            <div className="subtitle">Button</div>
            <label>Enter button text</label>
            <input 
                type="text"
                {...register("data[buttonText]", { required: "Text is required" })}
                placeholder={"Button text"}
                defaultValue={activity['data']['buttonText']}
            />
            <div className="error">{errors['data'] ? errors['data']['buttonText']?.message : ''}</div>
            
                        
            
        </>
        
    )

}        
        
